import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import map from "lodash/map";
import get from "lodash/get";

import set from "@rill/set";
import cx from "classnames";
import SettingsNav from "../../parts/settings-nav";
import SvgIcon from "../../parts/SvgIcon";
import { useRillContext } from "../../rill/RillReact/share/base";
import { formatNotificationDate } from "../../utils/date-helpers";

const {
  NOTIFICATIONS: { ICONS },
} = require("../../constants");

function View(props) {
  const { locals } = useRillContext();
  const { t } = useTranslation("dashboard");

  const { listNotifications, momentTZ } = locals;
  const [selectedList, setSelectedList] = useState([]);
  const handleSelectNotification = (e, id) => {
    e.preventDefault();
    setSelectedList((list) => {
      if (list.indexOf(id) > -1) {
        return list.filter((item) => item !== id);
      } else {
        return [...list, id];
      }
    });
  };
  const handleDeselectAll = (e) => {
    if (e) e.preventDefault();
    setSelectedList([]);
  };

  const handleSelectAll = (e) => {
    e.preventDefault();
    const selected = listNotifications
      .filter(({ read }) => !read)
      .map(({ _id }) => _id);
    setSelectedList(selected);
  };
  const unread = useMemo(() => {
    return listNotifications.filter((notification) => !notification.read)
      .length;
  }, [listNotifications]);
  const allSelected = unread === selectedList.length;
  const handleMarkRead = (e) => {
    e.preventDefault();
    submit(`/actions/notification/read-all`, {
      method: "POST",
      // body: {
      //   notifications: selectedList.length
      //     ? selectedList
      //     : notificationList.filter(({ read }) => !read).map(({ _id }) => _id),
      // },
    });
    handleDeselectAll();
  };
  return (
    <main className="settings">
      <SettingsNav />
      {/* <a className="settings" href="/dashboard/settings/notifications">
        Notification Settings
      </a> */}

      <section className="notifications">
        <header>
          <h3>{t("notifications.title")}</h3>
          <hgroup>
            <div></div>
            {unread > 0 && (
              <button data-button-type="primary" onClick={handleMarkRead}>
                {selectedList.length
                  ? t("notifications.markSelectedAsRead", {
                      count: selectedList.length,
                    })
                  : t("notifications.markAllAsRead")}
              </button>
            )}
          </hgroup>
        </header>
        <section role="table-wrapper" data-borders-inside>
          <table role="report-table">
            <thead>
              <tr>
                <th>
                  {unread > 0 && (
                    <SvgIcon
                      src={
                        allSelected
                          ? "/img/new-icons/checked-square.svg"
                          : "/img/new-icons/unchecked-square.svg"
                      }
                      onClick={
                        allSelected ? handleDeselectAll : handleSelectAll
                      }
                    />
                  )}
                </th>
                <th>{t("notifications.date")}</th>
                <th>{t("notifications.description")}</th>
                <th>{t("notifications.action")}</th>
              </tr>
            </thead>
            <tbody>
              {map(listNotifications, (notification) => {
                const isSelected = selectedList.includes(notification._id);
                const notificationText =
                  notification.type === "Push"
                    ? t("notifications.pushNotificationText")
                    : notification.text;
                return (
                  <tr key={notification._id}>
                    {!notification.read && (
                      <a
                        className="mark-read"
                        href={`/actions/notification/read/${notification._id}`}
                      >
                        <img
                          src="/img/svg/icon_dismiss.svg"
                          alt={t("notifications.dismissAlt")}
                        />
                      </a>
                    )}
                    <td>
                      {!notification.read ? (
                        <SvgIcon
                          src={
                            isSelected
                              ? "/img/new-icons/checked-square.svg"
                              : "/img/new-icons/unchecked-square.svg"
                          }
                          onClick={(e) =>
                            handleSelectNotification(e, notification._id)
                          }
                        />
                      ) : (
                        <img
                          src="/img/new-icons/read-notification.svg"
                          height={24}
                          width={24}
                        />
                      )}
                    </td>
                    <td className="date">
                      {formatNotificationDate(
                        notification.createdAt || notification.date,
                        momentTZ
                      )}
                    </td>

                    <td className="title">
                      {notification.read ? (
                        <span>{notificationText}</span>
                      ) : (
                        <b>{notificationText}</b>
                      )}
                    </td>

                    {notification.button && (
                      <td className="actions">
                        <a
                          role="button"
                          data-button-type="outline"
                          href={notification.button.link.replace(
                            "http://app.mystrengthbook.com",
                            ""
                          )}
                        >
                          <span>{notification.button.text}</span>
                        </a>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      </section>
    </main>
  );
}

const Notifications = (app) => {
  app.get(
    "/notifications",
    set("heading", ["Notifications"]),
    ({ res, api, locals }) => (res.body = <View />)
  );
};

export default Notifications;
